class AdpSelectController {
  constructor() {
    this.name = 'adpSelect';
  }
}

export default AdpSelectController;



// WEBPACK FOOTER //
// ./src/app/components/adpSelect/adpSelect.controller.js